"use client"

import type React from "react"
import {
  SessionProvider,
  type UseSessionReturn,
  RoomAudioRenderer,
  type SessionProviderProps,
  type RoomAudioRendererProps,
} from "../react"
import type { Room } from "../client"

export type AgentSessionProviderProps = SessionProviderProps &
  RoomAudioRendererProps & {
    room?: Room
    volume?: number
    muted?: boolean
    session: UseSessionReturn
    children: React.ReactNode
  }

export function AgentSessionProvider({
  session,
  children,
  ...roomAudioRendererProps
}: AgentSessionProviderProps) {
  return (
    <SessionProvider session={session}>
      {children}
      <RoomAudioRenderer {...roomAudioRendererProps} />
    </SessionProvider>
  )
}
